exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 768px) {\r\n  /* For mobile phones: */\n.invoice-view-page {\r\n    padding-left: unset !important;\n}\n.invoice-view-page .invoice-sidebar{\r\n  display: none;\n}\r\n /* .page-header .page-actions{\r\n  display: none;\r\n } */\n}\r\n\r\n\r\n\r\n\r\n", ""]);

// exports
